import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Skills from "./components/Skills";
import Exp from "./components/Exp";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <Skills />
      <Exp />
    </div>
  );
}

export default App;
